import { iFullStoreState, iList, iTag, iFavorites, iPerson } from "../../shared/interfaces";

export const selectTags = (s: iFullStoreState): iList<iTag> => s.general.tags;

export const selectFavorite = (s: iFullStoreState): { [type: string]: { [key: string]: boolean; } } => s.general.favorites;

export const selectPeopleKeys = (s: iFullStoreState): string[] => Object.keys(s.general.people);

export const selectPeople = (s: iFullStoreState): iList<iPerson> => s.general.people;
